@if(currentLang !== ''){
<div class="language-wrapper dropdown d-lg-block d-none">
  <button  name="language-btn" class="btn language-btn dropdown-toggle d-flex align-items-center gap-2 text-white" type="button"
    data-bs-toggle="dropdown" aria-expanded="false">
    <img [src]="getFlag(currentLang)" alt="{{ currentLang }}" class="flag-icon w-50">
  </button>

  <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 ">
    @for (lang of availableLangs; track lang) {
    <li>
      <button name="btn-language" class="dropdown-item d-flex align-items-center gap-2 text-color" (click)="onLangChange(lang)">
        <img [src]="getFlag(lang)" alt="{{ lang }}" class="flag-icon" width="31" height="31">
        {{ getLangLabel(lang) }}
      </button>
    </li>
    }
  </ul>
</div>

<div class="col-6 mx-auto d-block d-lg-none">
  <div class="d-flex">
    @for (lang of availableLangs; track lang) {
    <div class="mx-auto">
      <button name="btn-language" class="btn  p-0 m-0" (click)="onLangChange(lang)">
        <img [src]="getFlag(lang)" alt="{{ lang }}" class="w-flag" width="31" height="31">
        {{ getLangLabel(lang) }}

      </button>
    </div>

    }
  </div>
</div>
}